import { ReactComponent as InfoCircleIcon } from './infoCircleIcon.svg';
import { ReactComponent as WarningCircleIcon } from './warningCircleIcon.svg';

const svgIcons: any = {
  InfoCircleIcon,
  WarningCircleIcon,
};

export default svgIcons;
